import React from 'react'
import dummy from '../images/dummy.jpg'

export default function Inner_section1() {
  return (
    <>
       <div className="container main-section1-container">
        <div className="row row-cols-2 main-row-section1">
            <div className="col content-area-inner-section">
                <div className="heading-contant-area">
                    <h3>WEBSITE DEVELOPMENT SERVICES WEBSITE 
                    DEVELOPMENT SERVICES</h3>
                </div>
                <div className="contant-area-para">
                    <p>Digital Marketing Services that are aligned to your business' growth targets
By implementing a strategy-first approach, our team identifies the right approach aligned to 
the goals of your business. This process includes a full competitor audit together with an outline of the messaging, content and services required to achieve your business' growth targets.
Our digital marketing strategies are designed to meet the customer where they are at in the 
buyer's journey and ultimately convert them into loyal customers and long standing brand advocates. This is done through smart and personalized digital marketing services, creative thinking and transformative technology, ensuring effective and measurable results</p>
                </div>
            </div>
            <div className="col img-area-section">
                <img src={dummy} alt="" />
            </div>
            <div className="col outside-para">
            <div className="outside-para">
            <p>Digital Marketing Services that are aligned to your business' growth targets By implementing a strategy-first approach, our team identifies the right approach aligned to 
the goals of your business. This process includes a full competitor audit together with an outline of the messaging, content and services required to achieve your business' growth targets. Our digital marketing strategies are designed to meet the customer where they are at in the buyer's journey and ultimately convert them into loyal 
customers and long standing brand advocates. This is done through smart and personalized digital marketing services, creative thinking and transformative technology, ensuring effective and measurable results.</p>
        </div>
            </div>
        </div>
       
    </div>
    </>
  )
}
